import { createSlice } from '@reduxjs/toolkit'

export const CreateProjectTargetLanguageSlice = createSlice(
  {
  name: 'target_language_for_project_creation',
  initialState: {
    value: [],
  },
  reducers: {
    updateTargetLanguage: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { updateTargetLanguage } = CreateProjectTargetLanguageSlice.actions

export default CreateProjectTargetLanguageSlice.reducer